












import { Component, Vue, Prop, Mixins } from 'vue-property-decorator';
import { AA } from '@/lib/mixin';
import { aplusArticleButtonClick } from "../lib/qtLIb"

@Component
export default class ArticleList extends Mixins(Vue, AA) {
  @Prop() articles!: Article[];
  @Prop() tabIndex!: string;
  @Prop() itemtype!: string;
  @Prop({ default: '' }) searchKeyword!: string;
  @Prop({ default: '' }) searchType!: string;
  @Prop({ default: '' }) catalogName!: string;

  public scrollToTop() {
    const element = window.document.querySelector(`li.cell:first-child`) as HTMLElement | undefined;
    element?.scrollIntoView(true);
  }

  mounted() {
    console.log('TCL: ArticleList -> mounted -> this.itemtype', this.itemtype)
  }

  view(item: Article): void {
    this.$emit('viewKBItem', item)
    const eventName = this.tabIndex == "0" ? 'sllp_article_clk' : 'selp_article_clk'
    window.console.log('eventName:', eventName)
    aplusArticleButtonClick({
      // eslint-disable-next-line @typescript-eslint/camelcase
      event_name: eventName,
      // eslint-disable-next-line @typescript-eslint/camelcase
      article_id: item.id,
      // eslint-disable-next-line @typescript-eslint/camelcase
      title_type: this.itemtype,
      // eslint-disable-next-line @typescript-eslint/camelcase
      article_name: item.title,
      // eslint-disable-next-line @typescript-eslint/camelcase
      search_contents: this.searchKeyword,
      // eslint-disable-next-line @typescript-eslint/camelcase
      search_type: this.searchType,
      // eslint-disable-next-line @typescript-eslint/camelcase
      current_category: this.catalogName
    })
    const actionName = `view_${item.type}_${item.title}`;
    this.tracking({ isAction: true, pageName : 'KB', prePageName: 'Home', actionName });

    if (item.type === 'IMAGE') {
      // this.$router.push({path: '/imgpg', query: {bgimage: item.url}});
      this.$router.push({path: `/imgpg/${item.id}`});
    } else if (item.type === 'VIDEO') {
      this.$router.push(`/video/${item.id}`);
    } else {
      window.location.href = item.url;
    }
  }
}
